import Swiper from 'swiper/bundle';

class SwiperSingle {
  constructor({ elm }) {
    this.swiper = new Swiper(elm, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      centeredSlides: true,
      centerInsufficientSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 750,
      navigation: {
        nextEl: elm.querySelector('[data-role="single-swiper-nav-next"]'),
        prevEl: elm.querySelector('[data-role="single-swiper-nav-prev"]'),
      },
      pagination: {
        el: '[data-role="single-swiper-pagination"]',
        clickable: true,
      },
    });
  }
}

export default SwiperSingle;
